import { searchChatList, searchChatList20 } from "@/config/service/chatList.js";
import { userOne, userUpdate } from "@/config/service/user.js";

const state = {
  loginUserInfo: null || uni.getStorageSync("loginUserInfo"), // 登录用户信息
  chatList: [], // 登录用户的聊天列表
  corresponding_user_information: {}, // 对应用户的信息
  chatListHistory: [], // 聊天的历史记录

  oldChatKey: null, // 旧聊天key
  newChatKey: null, // 新聊天key

  popularRecommendation: [],

  searchChatList20: [],  // 人气推荐前20

  isVersionUpdate: false,    // 是否更新

  refreshToken: null
};

const mutations = {
  SET_REFRESHTOKEN: (state, data) => {
    state.refreshToken = data;
  },

  SET_ISVERSIONUPDATE: (state, data) => {
    state.isVersionUpdate = data;
  },

  SET_USERINFO: (state, data) => {
    state.loginUserInfo = data;
  },
  SET_CHATLIST: (state, data) => {
    state.chatList = data;
  },
  SET_CORRESPONDING_USER_INFORMATION: (state, data) => {
    state.corresponding_user_information = data;
  },
  SET_CHATLISTHISTORY: (state, data) => {
    state.chatListHistory = data;
  },
  SET_OLDCHATKEY: (state, data) => {
    state.oldChatKey = data;
  },
  SET_NEWCHATKEY: (state, data) => {
    state.newChatKey = data;
  },
  SET_POPULARRECOMMENDATION: (state, data) => {
    state.popularRecommendation = data;
  },
  SET_SEARCHCHATLIST20: (state, data) => {
    state.searchChatList20 = data;
  },
};

const actions = {

  async refreshToken({ commit }, refreshToken) {
    // 调用后端刷新接口
    const res = await uni.request({
      url: process.env.VUE_APP_HTTP + '/frontEnd_auth/refresh_token',
      method: 'POST',
      data: { refreshToken }
    })

    const data = res[1]
    if (data.statusCode !== 201) { throw new Error('刷新失败') }

    console.log(data,"KKKKKKKKKKKKKKKKKK");

    console.log(data.data.token,'data.data.tokendata.data.tokendata.data.token');
    
    

    // 保存新 token
    uni.setStorageSync('token', data.data.token)
    uni.setStorageSync('refreshToken', data.data.refreshToken)

    return data.data.token
  },





  /**
   *
   * @param {初始化获取用户信息} param0
   * @returns
   */
  initUserInfo({ commit }) {
    return new Promise((resolve, reject) => {
      const token = uni.getStorageSync("token");
      const openId = uni.getStorageSync("loginInfo").openid;
      const userInfo = uni.getStorageSync("userInfo");

      if (token) {
        userOne(openId)
          .then((res) => {
            const { data } = res;
            uni.setStorageSync("loginUserInfo", data); //  设置登录用户的信息
            commit("SET_USERINFO", data);
            commit("SET_ISVERSIONUPDATE", true);
            // 当userInfo存在的时候 执行修改
            if (userInfo && data.isRegister === 0) {
              userInfo.isRegister = 1;
              userUpdate(data.id, userInfo).then(() => {
                Object.assign(data, userInfo);
                uni.setStorageSync("loginUserInfo", data); //  设置登录用户的信息
                uni.removeStorageSync("userInfo");
                resolve(data);
              });
            } else {
              resolve(data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      } else {
        reject(new Error("查询登录用户信息错误"));
      }
    });
  },

  /**
   * 初始化获取聊天列表
   */
  // chatListInfo({ commit, state }, {uOpenId,cOpenId}) {
  //   return new Promise(async (resolve, reject) => {
  //     const token = uni.getStorageSync("token");
  //     if (token) {
  //       const params = {
  //         pageNum: 1,
  //         pageSize: 999,
  //       };
  //       const { data } = await searchChatList(params, uOpenId,cOpenId);
  //       commit("SET_CHATLIST", data.data);
  //       resolve(data.data);
  //     } else {
  //       reject(new Error("查询聊天列表错误"));
  //     }
  //   });
  // },

  /**
   *
   * @param {进入聊天室获取指定的双方chat信息} param0
   * @returns
   */
  chatListRoomInfo({ commit, state }, { uOpenId, cOpenId }) {
    return new Promise(async (resolve, reject) => {
      const token = uni.getStorageSync("token");
      if (token) {
        const params = {
          pageNum: 1,
          pageSize: 999,
        };
        const { data } = await searchChatList(params, uOpenId, cOpenId);
        // commit("SET_CHATLIST", data.data);
        resolve(data.data);
      } else {
        reject(new Error("查询聊天列表错误"));
      }
    });
  },

  searchChatList20({ commit }, gender) {
    console.log('searchChatList20');
    
    return new Promise(async (resolve, reject) => {
      let sex = '';
      if (gender === '女') {
        sex = '男'
      } else {
        sex = '女'
      }
      const token = uni.getStorageSync("token");
      if (token) {
        const { data } = await searchChatList20(sex);
        if (data) {
          commit("SET_SEARCHCHATLIST20", data.data)
          // uni.setStorageSync("searchChatList20", data.data); //  设置用户聊天列表
        }
        resolve(data);
      } else {
        reject(new Error("查询聊天列表错误"));
      }
    });
  },

  // Other actions can be added here
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
